import styled, { css } from 'styled-components'

export const OpenInNewTab = styled.a`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.25rem;
    height: 2.25rem;
    border: none;
    border-radius: ${theme.border.radius.large};
    background: ${theme.colors.white};
    color: ${theme.colors.dark};
    text-decoration: none;
    cursor: pointer;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);

    svg {
      font-size: 1.1rem;
    }
  `}
`
